export const applicationActions = {
    ALERT: 'ALERT',
    CLEAR_ALERTS: 'CLEAR_ALERTS',
    FAILURE: 'FAILURE',
    SUCCESS: 'SUCCESS',
    PENDING: 'PENDING'
};

export const applicationAlertsTypes = {
    NONE: '',
    SUCCESS: 'success',
    ERROR: 'danger',
    WARNING: 'warning'
};

const initState = {};

export const applicationReducer = (state = initState, action: any) => {
    switch (action.type) {
        case applicationActions.ALERT:
            return Object.assign({}, state, action.payload);

        case applicationActions.CLEAR_ALERTS:
            return Object.assign({}, state, action.payload);

        case applicationActions.FAILURE:
            return Object.assign({}, state, action.payload);

        case applicationActions.PENDING:
            return Object.assign({}, state, action.payload);

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/reducers/applicationReducer.ts